import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios';
import apiService from '../../../common/api.service';
import * as dom from "../../models/domain";

const initialState: dom.RegReportDefinitionState = {
    records: [],
    loading: 'idle',
    error: null
}


export const saveReportDefinition = createAsyncThunk(
    'regReportDefinitions/saveReportDefinition',
    async (data: dom.SaveRegReportDefinition) => {
        try {

            if (data.files) {
                for (let file of data.files) {
                    await apiService.uploadFile(file.filePath, file.blob);                    
                }
            }
            data.files = undefined;
         
            const response = await apiService.post<dom.SaveRegReportDefinition>('/reportdefinition', data) as AxiosResponse<dom.RegReportDefinition>
            if (response) {
                return response.data
            } else {
                throw new Error('unknown error saving report definition');
            }
        } catch (e) {
            const error = e as any;
            if (error.response?.data?.errors) throw new Error(error.response?.data?.errors)
            else throw error
        }
    }
)

export const deleteReportDefinition = createAsyncThunk(
    'regReportDefinitions/deleteReportDefinition',
    async (id: string) => {
        const response = await apiService.delete<any>('/reportdefinition/' + id, undefined) as AxiosResponse<any>
        if (!response) {
            throw new Error('unknown error deleting audit rule');
        }
    }
)

export const loadReportDefinitions = createAsyncThunk(
    'regReportDefinitions/loadReportDefinitions',
    async () => {
        const response = await apiService.get('/reportdefinition') as AxiosResponse<dom.RegReportDefinition[]>
        if (response) {
            return response.data
        } else {
            throw new Error('unknown error loading report definitions'); 
        }
    }
)



const sliceReducer = createSlice({
    name: 'regReportDefinitions',
    initialState,
    reducers: {
    },
    extraReducers: builder => {

        // save
        builder.addCase(saveReportDefinition.fulfilled, (state, action) => {
            return {
                ...state,
                records: [...state.records.filter(t => t.id !== action.payload.id), action.payload],
                loading: 'succeeded',
                error: null,
            }
        })
        builder.addCase(saveReportDefinition.rejected, (state, action) => {
            return { ...state, loading: 'failed', error: action.error }
        })

        // load
        builder.addCase(loadReportDefinitions.fulfilled, (state, action) => {
            return {
                ...state,
                records: action.payload,
                loading: 'succeeded',
                error: null,
            }
        })
        builder.addCase(loadReportDefinitions.rejected, (state, action) => {
            return { ...state, loading: 'failed', error: action.error }
        }) 

        // delete
        builder.addCase(deleteReportDefinition.fulfilled, (state, action) => {
            return {
                ...state,
                records: state.records.filter(t => t.id !== action.meta.arg),
                loading: 'succeeded',
                error: null,
            }
        })
        builder.addCase(deleteReportDefinition.rejected, (state, action) => {
            return { ...state, loading: 'failed', error: action.error }
        }) 
        
    }
}).reducer
export default sliceReducer

//https://redux-toolkit.js.org/usage/usage-with-typescript/
